<template>
  <div>
    <section class="page-section">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <h2 class="section-title">
              {{ $t('label.title.ratingAndRecommendation') }}
            </h2>
          </div>
          <div class="col-md-12">
            <div class="row">
              <div class="offset-1 col-10 section-carousel">
                <carousel
                  loop
                  autoplay
                  autoplay-hover-pause
                  center-mode
                  :per-page="1"
                  :pagination-enabled="true"
                  :navigation-enabled="true"
                  :navigation-next-label="nextIcon"
                  :navigation-prev-label="prevIcon"
                  :autoplay-timeout="5000"
                >
                  <template v-for="(item, key) in reviews">
                    <slide
                      class="pl-1 pr-1"
                      :key="key"
                    >
                      <div class="testimonial-item">
                        <div class="testimonial-container">
                          <div>
                            <div class="testimonial-opinion-container">
                              <div
                                class="row"
                                style="width: 100%"
                              >
                                <div class="offset-lg-1 col-lg-3">
                                  <div
                                    class="avatar"
                                    :style="`background-image: url(${item.avatar}) !important;`"
                                  />
                                </div>
                                <div class="col-lg-7">
                                  <div class="testimonial-content-font">
                                    {{ item.content && item.content.content_en ? item.content['content_' + $i18n.locale] : $t(item.content) }}
                                  </div>
                                  <div class="avatar-name mt-2">
                                    <div class="content-header">
                                      {{ item.name && item.name.name_en ? item.name['name_' + $i18n.locale] : item.name }}
                                    </div>
                                    <div
                                      class="content-body"
                                      v-if="item.position"
                                    >
                                      {{ item.position }}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </slide>
                  </template>
                </carousel>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section>
      <div class="container-fluid position-relative">
        <div class="position-absolute footer-footer" />
        <div class="container">
          <div class="row">
            <div
              class="col-md-12"
              style="padding: 0 !important;"
            >
              <img
                src="/img/footer.png"
                alt=""
                class="d-none d-md-block"
                style="width: 100%"
              >
              <img
                src="/img/mb-footer.png"
                alt=""
                class="d-block d-md-none"
                style="width: 100%"
              >
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>

export default {
  name: 'HomeRatingAndRecommendation',
  data () {
    return {
      nextIcon: '<i class="fa fa-angle-right" style="font-size: 50px"></i>',
      prevIcon: '<i class="fa fa-angle-left" style="font-size: 50px"></i>',
      reviews: [
        {
          name: {
            name_km: 'ស្រី លាប',
            name_en: 'Sreyleap'
          },
          content: {
            content_km: 'ល្អ ការឆ្លើយតបរហ័ស និងទំនាក់ទំនងល្អជាមួយអតិថិជន។',
            content_en: 'Good, fast reply and relationship with customer good.'
          },
          avatar: '/img/reviewers/04-sreyleap.png',
          position: 'Real Estate Agent, Unity Real Estates Information'
        },
        {
          name: {
            name_km: 'សុវឌ្ឍនា',
            name_en: 'Sovathana'
          },
          content: {
            content_km: 'សេវាលឿន និង ងាយស្រួល។',
            content_en: 'The Fastest service and easy.'
          },
          avatar: '/img/reviewers/05-sovathana.png',
          position: 'Software Engineer, IG International Group Company'
        },
        {
          name: {
            name_km: 'សុវណ្ណ',
            name_en: 'Sovan'
          },
          content: {
            content_km: 'Cashhero ងាយស្រួល និង ឆាប់រហ័ស។',
            content_en: 'Easy and Fast. Cash hero'
          },
          avatar: '/img/reviewers/06-sovan.png',
          position: 'Electrician, RT Company'
        },
        {
          name: {
            name_km: 'បញ្ញារ័ត្នន៍',
            name_en: 'Pagnarath'
          },
          content: {
            content_km: 'CashHero ជាក្រុមហ៊ុនប្រាក់កម្ចីដែលមានសេវាកម្មល្អ និង ងាយស្រួលក្នុងការកម្ចី។',
            content_en: 'CashHero is a good service company and easy to get loan!'
          },
          avatar: '/img/reviewers/10-pagnarath.png',
          position: 'Sale Supervisor, Trading'
        },
        {
          name: {
            name_km: 'សុវត្តី',
            name_en: 'Sovattey'
          },
          content: {
            content_km: 'សេវាកម្មល្អ និង ឆាប់រហ័ស ក្នុងការដាក់កម្ចី។',
            content_en: 'Best and Fast service to get an urgent loan.'
          },
          avatar: '/img/reviewers/11-sovattey.png',
          position: 'Accountant, Financial Institute of Cambodia'
        },
        {
          name: {
            name_km: 'ម៉ូលីកា',
            name_en: 'Molika'
          },
          content: {
            content_km: 'សេវាកម្មល្អ, រហ័សទាន់ចិត្ត តាមលទ្ធភាព និងងាយស្រួលក្នុងការសងត្រឡប់។ បុគ្គលិក និយាយសម្តី សមរម្យ នឹង គោរពអតិថិជន។',
            content_en: 'Good Service, quick and fast, have the size of the loan you can afford and easy to return. Staff is polite and respectful to customers.'
          },
          avatar: '/img/reviewers/12-molika.png',
          position: 'Accountant, Financial Institute of Cambodia'
        },
        {
          name: {
            name_km: 'Dom',
            name_en: 'Dom'
          },
          content: {
            content_km: 'សេវាកម្មល្អ និង ឆាប់រហ័ស ក្នុងការទទួលកម្ចីរហ័ស។',
            content_en: 'Best and fast service to get an urgent loan.'
          },
          avatar: '/img/reviewers/03-dom.png',
          position: 'Assistance, Ernst Young'
        },
        {
          name: {
            name_km: 'ណៃសៀក',
            name_en: 'Nayseak'
          },
          content: {
            content_km: 'សេវាកម្មឆាប់រហ័ស និង ងាយស្រួល។',
            content_en: 'The Fastest service and easy.'
          },
          avatar: '/img/reviewers/13-nayseak.png',
          position: 'Logistic, Lucky Limited'
        },
        {
          name: {
            name_km: 'ចាន់នួន',
            name_en: 'Channoun'
          },
          content: {
            content_km: 'សូមអរគុណ CashHero ដែលបានក្លាយជាជំនួយការទាន់ពេលវេលារបស់ខ្ញុំ។',
            content_en: 'Thanks CashHero for being my on time helper.'
          },
          avatar: '/img/reviewers/14-channoun.png',
          position: 'Logistic, Lucky Limited'
        },
        {
          name: {
            name_km: 'តារាវិសាល',
            name_en: 'Daravisal'
          },
          content: {
            content_km: 'សេវាកម្មល្អ និង ឆាប់រហ័ស។',
            content_en: 'Best Service and Fast'
          },
          avatar: '/img/reviewers/15-daravisal.png',
          position: null
        },
        {
          name: {
            name_km: 'លីន',
            name_en: 'Lin'
          },
          content: {
            content_km: 'CashHero គឺជាក្រុមហ៊ុនប្រាក់កម្ចីដែលមានសេវាកម្មល្អ និង ងាយស្រួល។',
            content_en: 'CashHero is a good service company and easy to get loan!'
          },
          avatar: '/img/reviewers/16-lin.png',
          position: null
        },
        {
          name: {
            name_km: 'Sreyleap',
            name_en: 'Sreyleap'
          },
          content: {
            content_km: 'សេវាកម្មល្អ ឆ្លើយតប នឹងមានទំនាក់ទំនងល្អជាមួយអតិថិជន។',
            content_en: 'Good service , fast reply and relationship with customer good.'
          },
          avatar: '/img/reviewers/17-sreyleap.png',
          position: 'Executive, PTT'
        }
      ]
    }
  }
}
</script>

<style scoped>

.testimonial-item {
  height: 100%;
}

.testimonial-container {
  width: 100%;
  background-color: white;
  border-radius: 10px;
  padding: 10px 20px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: 20px auto;
}

.testimonial-opinion-container {
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
}

.avatar {
  width: 150px;
  height: 150px;
  margin: 0 auto;
  border-radius: 50%;
  background-position: center;
  background-size: cover;
}

.footer-footer {
  background-color: var(--primary);
  width: 100%;
  bottom: 0;
  left: 0;
  right: 0;
  height: 20%;
}

@media screen and (max-width: 991px) {
  .testimonial-opinion-container {
    text-align: center;
    display: flex;
    justify-content: space-between;
    flex-direction: column-reverse;
  }

  .avatar {
    margin-bottom: 20px;
  }

  .avatar-container > .avatar {
    width: 60px;
    height: 60px;
  }

  .avatar-container > .avatar-name {
    margin-left: 10px;
  }
}
</style>
